<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingBriefingsIndex'
}
</script>
